const Prizes = [
  { coupon: "SITE30OFF", display: "30% SITEWIDE OFF", probability: 0.5 },
  { coupon: "HOTCHOCOLATE", display: "HOT CHOCLATE FREE WITH TEA", probability: 0.01 },
  {
    coupon: "FREETEA",
    display: "Free 50g tea on purchase of Rs. 500",
    probability: 0.04,
  },
  {
    coupon: "EFFERVESCENT",
    display: "Buy 2 Effervescent tablets & get 1 free",
    probability: 0.1,
  },
  {
    coupon: "FREEMUG",
    display: "FREE COFFEE MUG ON PURCHASE WORTH 1000+",
    probability: 0.15,
  },
  { coupon: "BUY1GET1", display: "BUY 1 GET 1 FREE", probability: 0.2 },
];

export default Prizes